import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { WarningWrapper } from "./WarningWrapper";

export const SubscriptionIncompleteExpired = () => (
  <WarningWrapper>
    <Typography.LabelLg weight="semibold">
      {t("subscription.incomplete_expired_title")}
    </Typography.LabelLg>
    <Typography.BodyMd color="text-default">
      {t("subscription.incomplete_expired_description")}
    </Typography.BodyMd>
  </WarningWrapper>
);
